import { Injectable } from '@angular/core';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { PaginationRequiredQueryInterface } from '@zaoblako/shared/common/dtos/pagination-required-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { UnitItemsPageInterface } from '@zaoblako/shared/modules/catalog/dtos/unit/unit-items-page.dto';
import type { UnitFindManyQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/unit/unit-find-many-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { DirectoryHistoryServiceInterface } from '@zaoblako/shared/common/interfaces/directory-history-service.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnitService extends BaseService implements DirectoryHistoryServiceInterface {
  protected baseUrl = '/basis/catalog/unit';

  public get dropdownDescriptorUrl(): string {
    return `${this.baseUrl}/dropdown-descriptor`;
  }

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: UnitFindManyQueryInterface): Observable<UnitItemsPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<UnitItemsPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public history(queryParams: PaginationRequiredQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public synchronize1cMany(): Observable<null> {
    return this.http.post<null>(`${this.baseUrl}/synchronize-1c`, {});
  }

  public synchronizeAtriumMany(): Observable<null> {
    return this.http.post<null>(`${this.baseUrl}/synchronize-atrium`, {});
  }

  public restore(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/restore`, {});
  }

  public getHistoryForOne(id: number, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }
}
